import * as React from 'react';

import Box from '../../Layout/Box';

import { StyledHeader } from './StyledHeader';

interface IHeaderProps {
  sections: React.ReactNode | React.ReactNode[];
}

const Header: React.FC<IHeaderProps> = ({ sections }) => {
  const sectionsArr: React.ReactNode[] = Array.isArray(sections) ? sections : [sections];

  return (
    <StyledHeader>
      <Box flexBasis='100%' position={{type: { small: 'relative' }}}>
        {sectionsArr.map((section, idx) =>
          <Box key={idx} flexBasis={`${(100 / sectionsArr.length)}%`}>{section}</Box>
        )}
      </Box>
    </StyledHeader>
  );
};

export default Header;
